import React from 'react';
import './Testimonial.css';

const Testimonial = ({ name, role, photo, quote }) => {
    return (
        <div className="testimonial-card">
            <div className="testimonial-header">
                <img src={photo} alt={name} className="testimonial-photo" />
                <div className="testimonial-info">
                    <h3 className="testimonial-name">{name}</h3>
                    <p className="testimonial-role">{role}</p>
                </div>
            </div>
            <p className="testimonial-quote">“{quote}”</p>
        </div>
    );
};

export default Testimonial;
